import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  authenticationActions,
  authorizationActions,
  personActions,
} from "../../store/store";
import classes from "./availabilitySelections.module.scss";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { TextField, Alert, FormControlLabel, Button, Typography } from '@mui/material';
import Cookie from "js-cookie";
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';
import { getNumWeeksFromNow, convertDateToIsoString, addMonths, subtractMonths, displayDate ,displayDateComaYear,alertGeneraliseMessage} from "../../Shared/Utill/Utills";
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import DailyAvailabilityTile from '../DailyAvailability/DailyAvailabilityTile'
import NotificationView from '../../Shared/Notification/NotificationView'
import AvailabilityTabs from './AvailabilityTabs'
import AvailabilityTypes from '../DailyAvailability/AvailabilityTypesInfo';
import {Checkbox, DatePicker } from "@genesis/ui-kit";
import { useLocation, useNavigate } from "react-router-dom";
import PreferenceSelectionTile from '../DailyAvailability/PreferenceSelectionTile';
import store from "../../store/store";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import DailyPWHCheckboxDialog from "./DailyPWHChecbox/DailyPWHCheckboxDialog";
import {ConfirmationTickIcon} from  '../../Resources/availabilityicon/AvailabilityIcons';
import moment from 'moment';
import { toUpperCaseString } from "../../Shared/Utill/Utills";
import Switch from "@mui/material/Switch";
import { Dialog, useToggle } from '@genesis/ui-kit';
import TimeOffPTOLinkComp, { ComponentType } from "./TimeOffPTOLinkComp";
import { isEmpty } from "../../Shared/Utill/Utills";
import SnackbarIcon from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import { messages } from "../../Shared/Messages/ErrorMessages";

const AvailabilitySelections = () => {
  const urlDetails = useSelector((state) => state.url.urlData);
  const personDetails = useSelector((state) => state.person.personData);
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
  const cutOffDetails = useSelector((state) => state.cutOffDate.cutOffDateData); 
  const ptoQuickRefLink = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_AVL_QRC;
  const ptoLink = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_PTO_URL;
  const location = useLocation();
  const [selectedDateValue, setSelectedDateValue] = React.useState(location.state);
  const [maxSelectDate, setmaxSelectDate] = React.useState("");
  const token = Cookie.get('X_TKN');
  const history = useNavigate();
  const [selectedDateData, setSelectedDateData] = React.useState([]);
  const workScheduleDetails = useSelector((state) => state.workSchedule.workScheduleData);
  const [dailyWeeklyData, setDailyWeelykdata] = React.useState([]);
  const [selectedWorkScheduleData, setSelectedWorkScheduleData] = React.useState({});
  const [dataByRuleId,setDataByRuleId] = React.useState({});

  const [appControlsData,setAppControlsData] = React.useState([]);
  const [selectedRuleId,setSelectedRuleId] = React.useState("");
  const [selectedARId,setSelectedARId] = React.useState("");
  const [ruleInfo, setRuleInfo] = React.useState({});
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const [showCheckboxDailyPopup, setShowCheckboxDailyPopup] = React.useState(false);
  const [showCheckboxPWHPopup, setShowCheckboxPWHPopup] = React.useState(false);
  const [checkBoxCutOffDate, setCheckBoxCutOffDate] = React.useState(null);
  const [checked, setChecked] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const dialog = useToggle();
  const [isAllDailyTileDisabled, setAllDailyTileDisabled] = React.useState(false);
  const [cutOffDateByDivNbr,setCutOffDateByDivNbr] = React.useState(null);
  const [weeklyDeadline, setWeeklyDeadline] = React.useState(null);
  const [wasDisplayed, setWasDisplayed] = React.useState(false);
  const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);
  
  console.log("slected", selectedDateData)

  // code for snackbar icon
  const [state, setState] = React.useState({
    snackopen: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, snackopen } = state;

  const handleClose = () => {
    setState({ ...state, snackopen: false });
  };

  const gotoSpecial = () => {
    history('/specialevents')
  }

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setState({ ...state, snackopen: false });
  };


  useEffect(() => {
    getCutOffDateByDivNbrActive();
  },[])

  useEffect(() => {
    // initial component load call which calls the fsccalender api 
    getWeekData("initial landing",selectedDateValue);
  }, [cutOffDateByDivNbr]);

  useEffect(() => {
    // Once selected date data is loaded filtering the redux data to get current work schedule
    setActiveWorkSchedule(selectedDateValue);
  }, [selectedDateData]);

  useEffect(() => {
    // Integrate getRule Id API and Check if we have valid rule id proceed with normal flow otherwise show Something Went Wrong Page
    //C.R.
    getMyAvailabilityRuleId(selectedDateData);
  },[selectedWorkScheduleData]);

  useEffect(() => {
    // get app Controls from get App controls APi once valid rule id value is fetched
    getAppControlsByAppDivLocDptWs();
    
  },[selectedARId]);

  useEffect(() => {
    // call the getByRuleARId api once ruleId and app controls fetched from API
    //C.R. 27th Jan 2023 by vishal verma- Instead of getRuleBYId integrate and use getbRuleByARId, Removed this API call-getDataByRuleId(selectedRuleId)
    //C.R. 9 Feb 2023, by vishal verma to interate new endpoint to get rule info by cutoffdate, base date & arid
    //Removed-- getRuleDataByARId(selectedARId);
   getRuleDataByARIdCutoffAndBaseDate(selectedARId,selectedDateData,cutOffDetails);
  }, [appControlsData]); 

  useEffect(() => {
    // call the getBasePageData api to load the tiles once every data is set on the page
    getSevenWeekDataService(selectedDateData);
  }, [dataByRuleId]); 

  useEffect(() => {
    //setCutoffDateControls();
    //get weekly deadline details; and then call getRuleInformation
    getWeeklyDeadline();
    //all this api to load info messages
    //--getRuleInformation();
  }, [dailyWeeklyData]);


  const setActiveWorkSchedule = (selectedDateValue = selectedDateValue) => {
    console.log("ws",workScheduleDetails)
    const filterByExpiration = () => workScheduleDetails.filter(({ adjstddate }) => new Date(adjstddate) <= new Date(selectedDateValue));
    let filter = filterByExpiration();
    var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
    console.log("max",max)
    setSelectedWorkScheduleData({...max})
  }

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const disableFuturechk = (maxDate) => {
    console.log("prevent movement "+ maxDate)
    setmaxSelectDate(maxDate);
  }

  const nextMonth = () => {
   let newDate = selectedDateData.fscBom.slice(0, 10);
   axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_CALENDAR_NEXTMONTH}/${newDate}`, {
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then((response) => {
      
      console.log(response.data.fscBom.slice(0, 10) + "date for comparison")
      let maxDate = new Date(maxSelectDate + " 00:00:00")
      let nextDate = new Date(response.data.fscBom.slice(0, 10) + " 00:00:00")
      console.log("max date is less than the limit " + maxDate < nextDate)
     if (maxDate > nextDate) {
      setSelectedDateValue(response.data.fscBom.slice(0, 10));
      getWeekData("next month",response.data.fscBom.slice(0, 10))
     }
    })
    .catch((error) => {
      if(error.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      } else {
     history("/somethingwentwrong", {state:`${constants.WFM_CALENDAR_NEXTMONTH}...failed`})
      }
    })
   
  }

  const prevMonth = () => {
    let newDate = selectedDateData.fscBom.slice(0, 10);;
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_CALENDAR_PREVMONTH}/${newDate}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
        console.log(response.data.fscBom.slice(0, 10) + "date for comparison")
      let maxDate = new Date(maxSelectDate + " 00:00:00")
      let nextDate = new Date(response.data.fscBom.slice(0, 10) + " 00:00:00")
      console.log("max date is less than the limit " + maxDate < nextDate)
     if (maxDate > nextDate) {
      setSelectedDateValue(response.data.fscBom.slice(0, 10));
      getWeekData("next month",response.data.fscBom.slice(0, 10))
     }
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
       history("/somethingwentwrong", {state:`${constants.WFM_CALENDAR_PREVMONTH}...failed`})
        }
      })
   
  }

  const setCalendar = (newDate) => {
    getWeekData("calendar",newDate)
  }

  

  const getWeekData = (origin,date) => {
    if(cutOffDateByDivNbr == null){
      return;
    }
    if(origin === 'calendar'){
      date = convertDateToIsoString(date)
    }
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_CALENDAR_GETCALENDERDATE}/${date}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {

        if(origin === "month"){
          setSelectedDateValue(response.data.fscBom);
        } else if(origin === "calendar"){
          setSelectedDateValue(date)
        }
        setSelectedDateData(response.data);
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
       history("/somethingwentwrong", {state:`${constants.WFM_CALENDAR_GETCALENDERDATE}...failed`})
        }
      })

  }

  /* sends new bow for selected Date update on tab select*/
  const getTabDate = (newDate) => {
   setSelectedDateValue(newDate)
   getWeekData("tab",newDate)
   console.log("newdate",newDate)
  }
  
  const handleCheckChangeAvailabilityThrough = () =>{
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
    setShowCheckboxDailyPopup(true);
    setShowCheckboxPWHPopup(false);
  }

  const handleCheckChangePrefrenceThrough  = () => {
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
   // setSelectedCheckboxPreferance(event.target.checked);
    setShowCheckboxPWHPopup(true);
    setShowCheckboxDailyPopup(false);

  }
  
  const handleChkSuccessCallback = (isDaily, msg) =>{
    setAlertOpen({
      open: true,
      severity: 'success',
      message : alertGeneraliseMessage('success'),
    })
    handleChkDismissCallback();
  }

  const handleChkFailCallback = (isDaily, msg) =>{
    setAlertOpen({
      open: true,
      severity: 'error',
      message : msg,
    })
    handleChkDismissCallback();
  }

  const handleChkDismissCallback = () =>{
    setShowCheckboxPWHPopup(false);
    setShowCheckboxDailyPopup(false);
  }

  //Fetch daily tiles data from API 
  const getSevenWeekDataService = (selectedData) => {
    if(Object.keys(selectedData).length === 0 || Object.keys(dataByRuleId).length === 0 ){
        return
    }
    // request Body
    let requestPayload = {
      "ascNbr" : personDetails.emplID,
      //"myDiv" : personDetails.mydiv,
      //"myStore" :personDetails.mystore,
      "myDiv" : personODSFuture.mydiv,
      "myStore" :personODSFuture.mystore,
      "fscyyyy" : selectedData.fscYyyy,
      "fscww": selectedData.fscWw,
      "fscBow": selectedData.fscBow,
      "fscEow": selectedData.fscEow,
      //"myDept": personDetails.mydept,
      "myDept": personODSFuture.mydept,
      "myWorkschedule": selectedWorkScheduleData.myworkschedule,
      "myWorkarea": personODSFuture.myworkarea,
      }
     console.log("payload API"+JSON.stringify(requestPayload)); 
    // Network request to get the seven days daily data
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVAILABILITY_SELECTION_PAGE_DATA}`,
      method: "POST",
      data: requestPayload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
      
    })
      .then((res) => {
        //console.log("Availability Selection API Respo"+ JSON.stringify(res));
        setDailyWeelykdata(res.data);
        if(toUpperCaseString(res.data.eventActive) === "Y" && wasDisplayed === false)   {
          setState({ ...state, snackopen: true });
          setWasDisplayed(true);
        }   
      })
      .catch((err) => {
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_AVAILABILITY_SELECTION_PAGE_DATA}...failed`})
        }

      });
     
  }
  //check cutoff Cal date & futurened control
  const setCutoffDateControls = () => {
    // let cutOffDateByDiv =  cutOffDatByDivNbr;
    // let cutOffDatefromFutureEndControl = null ;
    // if(cutOffDateByDiv !== null){
    //   cutOffDatefromFutureEndControl = cutOffDateByDiv;
    //   console.log("CutOFFDATE_BY_DIv_valid"+cutOffDateByDiv );
    // }else{
    //   let futureEndcontrols = appControlsData.find(x => x.ctlName === "futureend")
    //   console.log("This is the future end appcontrolinfo "+ JSON.stringify(futureEndcontrols))
    //   cutOffDatefromFutureEndControl = futureEndcontrols && futureEndcontrols.ctlValue01?futureEndcontrols.ctlValue01:null;  
    // }
    //set cutoff date in state for checkbox props
    //setCheckBoxCutOffDate(cutOffDatefromFutureEndControl);
    //disableFuturechk(cutOffDatefromFutureEndControl)
  }

  const calculateWeeksoutFn = ()=> {
    //TODO: weeksout changes apply here
    let controlsWeeksOut = appControlsData.find(x => x.ctlName === "wksout")
    console.log("This is the weeksout appcontrolinfo "+ JSON.stringify(controlsWeeksOut))
    let wksOutControlValue = controlsWeeksOut && controlsWeeksOut.ctlValue01?controlsWeeksOut.ctlValue01:null;
    let baseDate = selectedDateData.fscBow && (selectedDateData.fscBow).slice(0, 10);
    let substractDays = wksOutControlValue*7;
    let momentDate = moment(baseDate).format();
    let substractDaysDate =  moment(momentDate).subtract(substractDays,'days').format();
    let afterAddDaysDate =  moment(substractDaysDate).add(6,'days').format('MM/DD/YYYY');
    //---------------------------
    return afterAddDaysDate;
  }

  // get weekly Deadline
  const getWeeklyDeadline = () => {
    if(cutOffDateByDivNbr == null){
      return;
    }
    let baseDate = selectedDateData.fscBow && (selectedDateData.fscBow).slice(0, 10);
    let payload = {
      "fscCalDate": baseDate,
      "divNbr": personODSFuture.mydiv
    } 
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_FSC_CAL_DATE}`,
      method: "POST",
      data: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },   
    }).then((response) => {
        console.log(response.data)
        //TODO: check if we get weekDeadline 
        setWeeklyDeadline(response.data.weeklyDeadline);
         //all this api to load info messages
        getRuleInformation(response.data.weeklyDeadline);
      })
      .catch((error) => {
        setWeeklyDeadline(null);
         //all this api to load info messages
         getRuleInformation(null);
      })
  }

  // get rule information
  const getRuleInformation =  (weeklyDeadline) => {
    if(Object.keys(dataByRuleId).length === 0 ){
      return
    }
    let cutOffDateForRuleInfo = null;
    if(!isEmpty(weeklyDeadline)){
      cutOffDateForRuleInfo = weeklyDeadline;
    }else{
        cutOffDateForRuleInfo = calculateWeeksoutFn();
        //console.log("Calculated WeeksOut Date-->"+ calculateWeeksoutFn());
    }
    let requestPayload = {
      "nbrDaysOff": dataByRuleId.nbrdays_max_off,
      "nbrMorningsOff": dataByRuleId.nbrdays_max_am_off,
      "nbrEveningsOff": dataByRuleId.nbrdays_max_pm_off,    
      "hasAccomodation": dailyWeeklyData.svcAccomExists,
      "txtCutOffDate": cutOffDateForRuleInfo,
      "divNbr": personODSFuture.mydiv,
    } 
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_RULE_INFO}`,
      method: "POST",
      data: requestPayload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },   
    }).then((response) => {
        //console.log(response)
        setRuleInfo(response.data);
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_RULE_INFO}...failed`})
        }
      })
  }

  const getDataByRuleId = (ruleId) => {
    if(ruleId === "-1"){
      return;
    }
    if(ruleId !== "") {
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_RULES_BY_ID}/${ruleId}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
        setDataByRuleId(response.data);
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_RULES_BY_ID}...failed`})
        }
      })
    }
  }

  const getRuleDataByARId = (arId) => {
    if(arId === "-1" || arId == null){
      return;
    }
    if(arId !== "") {
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_RULES_BY_ARID}/${arId}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
        setDataByRuleId(response.data);
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_RULES_BY_ARID}...failed`})
        }
      })
    }
  }

  const getRuleDataByARIdCutoffAndBaseDate = (arId, selectedDate, cutoffDateObj) => {
    if(arId === "-1" || arId == null){
      return;
    }
    if(Object.keys(selectedDate).length === 0 ){
      return;
    }
    if(Object.keys(cutoffDateObj).length === 0){
      return;
    }
    if(arId !== "") {
    // request Body
    let requestPayload = {
      "arId": arId,
      "cutOffDate": cutoffDateObj.fscBow,
      "baseDate": selectedDate.fscBow.slice(0,10),
      "ascNbr": personDetails.emplID,
      "today": moment().format("YYYY-MM-DD"),
      }
     console.log("cut off date from REDUX", JSON.stringify(cutoffDateObj));
     console.log("RuleData API request payload:"+ JSON.stringify(requestPayload)); 
    // Network request 
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_RULES_BY_ARID_CUTOFFDATE_BASEDATE}`,
      method: "POST",
      data: requestPayload,
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      }).then((response) => {
        setDataByRuleId(response.data);
      }).catch((error) => {
        if(error.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_RULES_BY_ARID_CUTOFFDATE_BASEDATE}...failed`})
        }
      })
    }
  }

  const getAppControlsByAppDivLocDptWs = () => {
    if(Object.keys(selectedWorkScheduleData).length === 0) {
      return;
    }
    // request Body
    let requestPayload = {
      "appAbbr": "AVL",
      // "divNbr": personDetails.mydiv,
      // "locNbr": personDetails.mystore,
      // "dptNbr": personDetails.mydept,
      "divNbr": personODSFuture.mydiv,
      "locNbr": personODSFuture.mystore,
      "dptNbr": personODSFuture.mydept,
      "myWorkSchedule": selectedWorkScheduleData.myworkschedule,
      "minified": 0
      }
    // Network request to get the App controles
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETAPPCONTROLS}`,
      method: "POST",
      data: requestPayload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
      
    }).then((res) => {
        setAppControlsData(res.data);
      })
      .catch((err) => {
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETAPPCONTROLS}...failed`})
        }
      });
  }

  const showSuccessMessage = (severity,msg) => {
    setAlertOpen({
      open: true,
      severity: severity,
      message : msg,
    })
    getWeekData("initial landing",selectedDateValue);
  }

  const handleChange = (event) => {
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
     dialog.show();    
  };

  const closeDialog = () => {
    dialog.hide();
  }

  const saveWeekSliderData = () => {
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
    // save week slider data
    let temp = {};
    let daysToBeUpdated = [];
    if(dailyWeeklyData) { 
      dailyWeeklyData.dailyData.map((e) => {
      console.log("daily123",e)
      
      temp.checkRulesOnly = "N";
      temp.ruleToCheck = "ALL";
      temp.ascNbr = personDetails.emplID;
      // temp.myDiv = personDetails.mydiv;
      // temp.myStore = personDetails.mystore;
      // temp.myDept = personDetails.mydept;
      temp.myDiv = personODSFuture.mydiv;
      temp.myStore = personODSFuture.mystore;
      temp.myDept = personODSFuture.mydept;
      temp.fscyyyy = selectedDateData.fscYyyy;
      temp.fscww = selectedDateData.fscWw;
      temp.arId = dataByRuleId.arId;
      temp.avlId =  e.avlId;
      temp.avlRuleId = dataByRuleId.ruleId;
      temp.lastUpdatedBy = personDetails.emplID;
      temp.impersonatedBy = personDetails.impersonate_admin_id;
      temp.avlLanguageCode = languageDetails.selected !== '' ? languageDetails.selected : 'en';
      if(e.svcAccom_hasAccom === 0) {
        daysToBeUpdated.push(e.dayNbr);
      }
      
      })
      temp.daysToBeUpdated = daysToBeUpdated;  
      
      console.log("Avail data", temp);
     
     axiosInstance({
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_SET_WEEKLY_AVAILABILITY_FROM_SLIDER}`,
        method: "POST",
        data : temp,
        headers:{
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' + token,
        },
        
      }).then((res) => {
          dialog.hide();
          setAlertOpen({
            open: true,
            severity: "success",
            message: res.data.message || "Availability updated successfully",
          });  
          // call get base page data api
          getSevenWeekDataService(selectedDateData);
        })
        .catch((err) => {
          dialog.hide();
          setAlertOpen({
            open: true,
            severity: "error",
            message: err.response.data.message || "Something went wrong",
          });          

        }); 
    }
  }

  const getMyAvailabilityRuleId = (selectedData) => {
    if(Object.keys(selectedWorkScheduleData).length === 0) {
      return;
    }
    if(Object.keys(selectedData).length === 0 ){
      return
  }
    // setting to call refresh api
    setSelectedRuleId("");
    setSelectedARId("");

    // request Body
    let requestPayload = {
      // "divNbr": personDetails.mydiv,
      // "locNbr": personDetails.mystore,
      // "dptNbr": personDetails.mydept,
      "divNbr": personODSFuture.mydiv,
      "locNbr": personODSFuture.mystore,
      "dptNbr": personODSFuture.mydept,
      "myWorkSchedule": selectedWorkScheduleData.myworkschedule,
      "myDateDisplayed": selectedData.fscBow.slice(0,10),
      }
    // Network request 
    axiosInstance({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFH_COMMON_GET_MY_AVAILABILITY_RULES}`,
      method: "POST",
      data: requestPayload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
      
    }).then((res) => {
        let resp = res.data;
        if(resp.length > 0){
          //C.R.-27 jan 2023 by vishal verma- instead of ruleId use ARId to get rule detail
          setSelectedRuleId(res.data[0].ruleId);
          setSelectedARId(res.data[0].arId);
          console.log("RESP--my availability Rule Id-->"+ res.data[0].ruleId);
        }
      })
      .catch((err) => {
        // error
        console.log("ErR" + err.response.data.error);
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFH_COMMON_GET_MY_AVAILABILITY_RULES}...failed. ${err.response.data.error}`})
        }
      });
  }

  const getCutOffDateByDivNbrActive = () => {
    //let divNbr = personDetails.mydiv;
    let divNbr = personODSFuture.mydiv;
      axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_ACTIVE}/${divNbr}`, {
     headers: {
       'content-type': 'application/json',
       'Authorization': 'Bearer ' + token
     }
   })
     .then((response) => {
       console.log(response.data+ "CUTOFF_DATA_BY_DIV_NUMBER_RESP");
      let cutOffDate = response.data.fscCalDate;
      //set cuttoffdate into State  
      setCutOffDateByDivNbr(cutOffDate);
      setCheckBoxCutOffDate(cutOffDate);
      disableFuturechk(cutOffDate);
     })
     .catch((err) => {
      //
      console.log("ErR" + err.response.data.message);
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      } else {
      history("/somethingwentwrong", {state:`${constants.WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_ACTIVE}...failed. ${err.response.data.message}`})
      }
       return null;
     })
    
   }


  const LoadPWHComponents = () => {
    return (
      <>
      {dataByRuleId && toUpperCaseString(dataByRuleId.preferences_visible) !== 'N' && <div>
      <NotificationView
       message={"Selections made under preferences are informational only."}/>
      <div>
        {dailyWeeklyData && <PreferenceSelectionTile showSuccessMessage={showSuccessMessage} appControls={appControlsData} ruleData={dataByRuleId} weeklyData = {dailyWeeklyData.wklyData}  wklyData={dailyWeeklyData.wklyData} fscData={selectedDateData} bow = {selectedDateData.fscBow} eow = {selectedDateData.fscEow}/>}
      </div>
          <div className={classes.openCloseText}>
          Click below to make this my preferences for "Future Weeks".  
          </div>
          <div >
            <Button disabled={dataByRuleId && toUpperCaseString(dataByRuleId.preferences_editable) !== 'Y'} color="secondary" style={{fontSize:"13.5px"}} onClick={event =>handleCheckChangePrefrenceThrough()} className={classes.applyButton}>Set Future Preferences</Button>
          </div> 
        <div>
        {showCheckboxPWHPopup &&
         <DailyPWHCheckboxDialog
          isDaily={false}
          cutOffDate={checkBoxCutOffDate}
          data={dailyWeeklyData}
          chkSuccessCallback={handleChkSuccessCallback}
          chkFailCallback={handleChkFailCallback}
          dismissDialog={handleChkDismissCallback}/>}
      </div>
      </div>}
      </>
    );
  }
  const maxAllowDate = moment(maxSelectDate,'YYYY-MM-DD').toDate();

  const callBackIsAllDailyTileDisabled = (status) => {
    setAllDailyTileDisabled(status);
  }

  const selectedDateLabels = (selectedDateData) => {
    let value = "";
    if(Object.keys(selectedDateData).length > 0){
    let bom = displayDate(new Date(selectedDateData.fscBom));
    let eom = displayDate(new Date(selectedDateData.fscEom));
      value = bom + "-"+ eom;
    }
        
   return <div style={{display: "inline-block"}}>{value}</div>;
  }
  return (
    <div className="main_body">
      <div className={classes.page_title_wrap}>
        <div className={classes.page_title}>
          Availability Selections
        </div>
        <TimeOffPTOLinkComp type={ComponentType.AVL}/>
      </div>
      <div className={classes.page_subtitle_wrap}>
      Select the week and day to indicate your availability. 
      </div>


      
      
      <SnackbarIcon
        key={"snakc"}
        anchorOrigin={{ vertical, horizontal }}
        open={snackopen}
        onClose={handleCloseSnack}
        className={personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined ? classes.snack_top : classes.snack_top_no_imperson }
        
      >
        <Alert
          sx={{ background: '#000000', color: "#fff" }}
        >
          You have a Special Event to review. <span style={{marginLeft:"10px", marginRight:"10px", textDecoration:"underline", cursor:"pointer"}} onClick={gotoSpecial} >Go To Special Event</span>
          <CloseIcon onClick={handleClose} style={{cursor:"pointer"}} />
        </Alert>
      </SnackbarIcon>

      <br />
      <div className={classes.info_icons_wrap}>
      <div className={classes.calendarContainer}>
        <div className={classes.calendarData} style={{paddingLeft:"0px"}}>
          <KeyboardArrowLeftSharpIcon onClick={prevMonth} className={classes.pointer}/> 
          {selectedDateLabels(selectedDateData)}
          <KeyboardArrowRightSharpIcon onClick={nextMonth} className={classes.pointer} />
        </div>
        
        <div className={classes.calendarData} style={{marginTop:"12px", paddingLeft:"0px"}}>
          <DatePicker
            maxDate={maxAllowDate}
            label="Custom input"
            inputFormat="yyyy-mm-dd"
            value={selectedDateValue}
            onChange={(newValue) => {
              setCalendar(newValue);
            }}
            renderInput={({ inputRef, inputProps, InputProps }) => (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>

                {InputProps?.endAdornment}
              </Box>
            )}
          /></div>

      </div>
      <AvailabilityTypes/>
      </div>
      <br />
      {selectedRuleId == '999' && <NotificationView
        message = {"Due to your work schedule, you have no required actions at this time."}/>}
      { personDetails.impersonate_admin_id !== null &&
      <>
      <div><b>Selected Calendar Date:</b> {(selectedDateValue)}</div>
      <div><b>Base Date for tabs and tiles:</b>  {selectedDateData.fscBow && (selectedDateData.fscBow).slice(0, 10)}</div>
      <div><b>Adjusted date from redux:</b>  {selectedWorkScheduleData.adjstddate}</div>
      <div><b>My Work Schedule from redux:</b>  {selectedWorkScheduleData.myworkschedule}</div>
      <div><b>My Rule ID from getMyAvailabilityRuleId:</b>  <span>{selectedRuleId}</span> | <span>ARId: {selectedARId}</span></div>
      <div><b>My Work Area :</b> {personODSFuture.myworkarea}</div>
      <div><b> My Department :</b>{personODSFuture.mydept}</div>
      </>
      }
      <KeyboardArrowLeftSharpIcon onClick={prevMonth} className={classes.pointer} fontSize="large" style={{position: "relative", top: "45px",left: "-28"}}/>
      <KeyboardArrowRightSharpIcon onClick={nextMonth} className={classes.pointer} fontSize="large" style={{position: "relative", top: "45px", right: "-98%"}} />
      <AvailabilityTabs sendBOW={getTabDate} weekOfMonth={selectedDateData.fscWkOfMth} baseDate={selectedDateData.fscBow && selectedDateData.fscBow.slice(0, 10)}/>

      <NotificationView
        message = {ruleInfo.txtCustomInfoMsg}/>

<Box>
                <Dialog
                    sx={{height: window.innerWidth < 768 ? '400px': 'auto'}}
                    open={dialog.open}
                    title={'Confirm Availabilty'}
                    onClose={closeDialog}
                    
                    actions={
                        <>
                            <Button color="secondary" onClick={closeDialog}>No</Button>
                            <Button onClick={saveWeekSliderData}>Yes</Button>
                        </>
                      }
                >
                  <Typography>{"Confirm your availability is “Open - Close” for the week."}</Typography>
                </Dialog>
            </Box>

        <div className={classes.openCloseText}>
          Click below to set my availability to “Open - Close” hours for the week.  
        </div>
        <div >
          <Button disabled={isAllDailyTileDisabled} color="secondary" style={{fontSize:"14px"}} onClick={handleChange} className={classes.applyButton}>Set Week Open-Close</Button>
        </div>
      <div className={classes.scrollhorz}>
        {dailyWeeklyData && <DailyAvailabilityTile 
                            showSuccessMessage={showSuccessMessage} 
                            ruleInfo={ruleInfo} 
                            appControls={appControlsData} 
                            ruleData={dataByRuleId} 
                            fscData={selectedDateData} 
                            dailyData={dailyWeeklyData.dailyData} 
                            baseDate={selectedDateData.fscBow && selectedDateData.fscBow.slice(0, 10)}
                            callBackAllDisabled={callBackIsAllDailyTileDisabled}/>
        }
      </div>
          <br></br>
         {(selectedRuleId != '999') && 
         <div>
            <div className={classes.openCloseText}>
              Click below to make this my availability for "Future Weeks".  
            </div>
            <Button disabled={isAllDailyTileDisabled} color="secondary" style={{fontSize:"14px"}} onClick={event =>handleCheckChangeAvailabilityThrough()} className={classes.applyButton}>Set Future Availability</Button>
          </div> 
         }
          
      <hr/>
     {/* PWH components here */}
      <LoadPWHComponents/>
      <div>
        {showCheckboxDailyPopup &&
        <DailyPWHCheckboxDialog
         isDaily={true} 
         cutOffDate={checkBoxCutOffDate}
         data={dailyWeeklyData}
         chkSuccessCallback={handleChkSuccessCallback}
         chkFailCallback={handleChkFailCallback}
         dismissDialog={handleChkDismissCallback}/>}
      </div>
    <div>
    <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
    </div>
    
    </div>

  );
};

export default AvailabilitySelections;